import { useState, useEffect } from 'react';
import BasicInfoStyled from './BasicInfoStyled';
import Radio from '@material-ui/core/Radio';
import {
  //  useDispatch,
  useSelector,
} from 'dva';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DateRangePickerML from '@/components/DateRangePickerML/DateRangePickerML';
import {
  Box,
  // Button
} from '@material-ui/core';
import {
  TextField,
  FormHelperText,
  FormControl,
  InputLabel,
  Chip,
  Select,
  MenuItem,
  useTheme,
  // SeletItem,
} from '@material-ui/core';
import dayjs from 'dayjs';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import { IconButton } from '@material-ui/core';
import DateTimePicker from '@material-ui/lab/DateTimePicker';
import TimePicker from '@material-ui/lab/TimePicker';
import ModalML from '@/components/ModalML';
import PeopleModal from '../operate_modal/people_modal/index';
import UploadFileML from '@/components/UploadFileML';
import { useIntl } from 'umi';
import { Controller } from 'react-hook-form';

function getStyles(name, arr, theme) {
  return {
    fontWeight:
      arr.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    color: '#000',
  };
}

const BasicInfo = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    cardType,
    setFileInfo,
    fileInfo,
    fileValidate,
    setFileValidate,
    status,
    setConsumer,
    activityGroupDetail,
  } = props;
  const theme = useTheme();
  //单次开始时间
  const [beginTimeValidate, setBeginTimeValidate] = useState(false);
  //频率为周期时的开始时间
  const [cycleStartTime, setCycleStartTime] = useState(null);

  //关于日期频率
  const [dateType, setDateType] = useState('ONCE');
  //当选择周期的时候
  const [dateCycle, setDateCycle] = useState('DAY');
  //周
  const [dateWeekDay, setDateWeekDay] = useState([]);
  //月
  const [dateMonthDay, setDateMonthDay] = useState([]);
  //拿到不同用户组数据
  const userGroupInfo =
    useSelector((state) => state.crowdAdd?.userGroupInfo) || {};
  //获取关于周期性的相关数据
  const circleData = useSelector((state) => state?.crowdAdd?.cycleData) || {};
  const { cycleTypeList, monthDayList, weekDayList } = circleData || {};
  //react-hook-from 表单相关
  const { control, errors, setValue } = props;
  // console.log('getValues', getValues());
  //关于时间日期的disbled
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    if (
      activityGroupDetail.executeType === 'EXECUTE_TIMING' &&
      activityGroupDetail?.dateType === 'ONCE' &&
      status === 'edit'
    ) {
      setDisabled(false);
    }
  }, [activityGroupDetail, status]);

  useEffect(() => {
    if (status !== 'add') {
      setDateType(activityGroupDetail?.dateType);
      setValue('dateType', activityGroupDetail?.dateType);
      if (activityGroupDetail?.dateType === 'ONCE') {
        if (activityGroupDetail.executeType === 'EXECUTE_TIMING') {
          setTimeout(() => {
            setDate(activityGroupDetail?.beginTime);
            setValue('beginTime', activityGroupDetail?.beginTime);
          });
        }
      } else if (activityGroupDetail?.dateType === 'CYCLE') {
        setTimeout(() => {
          setValue('dateCycle', activityGroupDetail.dateCycle);
          setDateCycle(activityGroupDetail.dateCycle);
        });
        if (activityGroupDetail?.dateCycle !== 'DAY') {
          setTimeout(() => {
            activityGroupDetail?.dateCycle === 'WEEK'
              ? setDateWeekDay(activityGroupDetail.dateDay || [])
              : setDateMonthDay(activityGroupDetail.dateDay || []);
            setValue('dateDay', activityGroupDetail.dateDay || []);
          });
        }
        const timeString = `
          ${dayjs().format('YYYY-MM-DD')} ${activityGroupDetail?.cycleTime}`;
        const time = dayjs(timeString);
        setTimeout(() => {
          setValue('cycleTime', time);
          setCycleStartTime(time);
        });
      }
      cardType === 'CUSTOM_CROWD' &&
        setValue('date', {
          startDate: activityGroupDetail.cycleStartDate,
          endDate: activityGroupDetail.cycleEndDate,
        });
      setUserGroup([activityGroupDetail.groupId]);
    }
  }, [activityGroupDetail, setValue, status]);

  //关于自定义人群
  const [userGroup, setUserGroup] = useState([]);
  //人群选择弹框
  const [openPeopleModal, setOpenPeopleModal] = useState(false);
  const handlePeopleCancel = () => {
    setOpenPeopleModal(false);
  };
  const handlePeopleSubmitSuccess = (id) => {
    setUserGroup(id);
    setConsumer(id[0]);
    setOpenPeopleModal(false);
  };
  const onPeopleClose = () => {
    setOpenPeopleModal(false);
  };
  const handleSelectPeople = () => {
    setOpenPeopleModal(true);
  };
  //受控组件日期
  const [date, setDate] = useState(null);
  const labelML = (
    <>
      <span className="label-require">*</span>
      <span className="label-name">
        {formatMessage({ id: 'marketing.people.regnotcon.n01.lbl02' })}
      </span>
    </>
  );
  return (
    <BasicInfoStyled>
      <Box className="title">
        {formatMessage({ id: 'marketing.people.regnotcon.n01.lbl01' })}
      </Box>
      <Box>
        <Controller
          className="campaignName"
          as={
            <TextField
              variant="standard"
              label={labelML}
              className="basic-name"
            />
          }
          control={control}
          disabled={status === 'detail'}
          name="title"
          defaultValue={activityGroupDetail?.title ?? ''}
          // placeholder="如：双十一优惠券，最多20字"
          rules={{
            required: true,
            maxLength: {
              value: 20,
            },
            validate: (e) => {
              const value = e.trim();
              return Boolean(value);
            },
          }}
        />
        <FormHelperText error={Boolean(errors.title)}>
          {errors.title?.type === 'required' &&
            formatMessage({ id: 'marketing.people.regnotcon.n02.lbl03' })}
          {errors.title?.type === 'maxLength' &&
            formatMessage({ id: 'marketing.people.regnotcon.n02.lbl04' })}
          {errors.title?.type === 'validate' &&
            formatMessage({ id: 'marketing.people.regnotcon.n02.lbl03' })}
        </FormHelperText>
      </Box>
      {cardType === 'CUSTOM_CROWD' && (
        <Box className="link" onClick={handleSelectPeople}>
          {status !== 'detail' &&
            formatMessage({ id: 'marketing.people.regnotcon.n02.lbl02' })}
        </Box>
      )}

      <Box mt={2}>
        <span className="label-require">*</span>
        <span className="label-name">
          {formatMessage({ id: 'marketing.people.regnotcon.n02.lbl01' })}
        </span>
      </Box>
      {cardType === 'ASSIGN_TELEPHONE' && (
        <>
          <Box mt={2}>
            <UploadFileML
              control={control}
              status={status}
              errors={errors}
              fileInfo={fileInfo}
              fileValidate={fileValidate}
              setFileValidate={setFileValidate}
              setFileInfo={setFileInfo}
              isDialog={true}
            />
          </Box>
        </>
      )}
      {cardType !== 'ASSIGN_TELEPHONE' && (
        <Box style={{ width: 400 }} mt={2} className="table">
          <div className="table-first">
            <span>
              {formatMessage({ id: 'marketing.people.regnotcon.c01.lbl01' })}
            </span>
            <span>
              {formatMessage({ id: 'marketing.people.regnotcon.c01.lbl02' })}
            </span>
          </div>
          <div className="table-second">
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <span>
                {userGroupInfo?.title}
                {/* 需要重点召回客户 */}
              </span>
              <span className="ask">
                <ButtonTip title={userGroupInfo?.remark ?? '暂无'}>
                  <IconButton>
                    <SvgIconML name="ask" size={12} color="#1565C0" />
                  </IconButton>
                </ButtonTip>
              </span>
            </Box>
            <span>{userGroupInfo?.quantity}</span>
          </div>
        </Box>
      )}

      <Box mt={2}>
        <span className="label-require">*</span>
        <span className="label-name">
          {formatMessage({ id: 'marketing.people.regnotcon.n03.lbl01' })}
        </span>
      </Box>
      <Box mt={2} mb={2} className="executeType">
        <Controller
          name="dateType"
          className="checkbox-radio-disabled-color"
          defaultValue="ONCE"
          control={control}
          as={
            <RadioGroup
              aria-label="gender"
              name="dateType"
              defaultValue="ONCE"
              disabled={status === 'detail'}
            >
              <Box>
                <FormControlLabel
                  control={<Radio />}
                  value="ONCE"
                  disabled={status === 'detail'}
                  label={formatMessage({
                    id: 'marketing.people.regnotcon.n03.rdo02',
                  })}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setDateType('ONCE');
                      // setDisabled(true);
                    }
                  }}
                />
                {dateType === 'ONCE' && (
                  <Box ml={3}>
                    <Controller
                      name="executeType"
                      className="checkbox-radio-disabled-color"
                      defaultValue="EXECUTE_IMMEDIATELY"
                      control={control}
                      as={
                        <RadioGroup
                          aria-label="gender"
                          name="executeType"
                          disabled={status === 'edit'}
                          defaultValue="EXECUTE_IMMEDIATELY"
                        >
                          <Box className="frequency-single-wrapper">
                            <Box className="row">
                              <FormControlLabel
                                value="EXECUTE_IMMEDIATELY"
                                control={<Radio />}
                                disabled={status === 'detail'}
                                label={formatMessage({
                                  id: 'marketing.people.regnotcon.n03.rdo03',
                                })}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setDisabled(true);
                                    setBeginTimeValidate(false);
                                  }
                                }}
                              />
                              <FormControlLabel
                                value="EXECUTE_TIMING"
                                control={<Radio />}
                                disabled={status === 'detail'}
                                label={formatMessage({
                                  id: 'marketing.people.regnotcon.n03.rdo04',
                                })}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setDisabled(false);
                                    setBeginTimeValidate(true);
                                  }
                                }}
                              />
                            </Box>
                            <Box className="beginTime-wrapper" mt={2}>
                              <Controller
                                control={control}
                                name="beginTime"
                                defaultValue={null}
                                rules={{
                                  required: beginTimeValidate,
                                }}
                                error={Boolean(errors.beginTime)}
                                as={
                                  <DateTimePicker
                                    disabled={disabled}
                                    inputFormat="yyyy/MM/dd HH:mm"
                                    renderInput={(prop) => (
                                      <TextField {...prop} variant="standard" />
                                    )}
                                    label={formatMessage({
                                      id: 'marketing.people.regnotcon.n03.rdo05',
                                    })}
                                    value={date}
                                    onChange={(newValue) => {
                                      setDate(newValue);
                                    }}
                                  />
                                }
                              />
                              <FormHelperText error={Boolean(errors.beginTime)}>
                                {errors.beginTime?.type === 'required' &&
                                  formatMessage({
                                    id: 'marketing.people.regnotcon.n03.msg02',
                                  })}
                              </FormHelperText>
                            </Box>
                          </Box>
                        </RadioGroup>
                      }
                    />
                  </Box>
                )}
              </Box>
              <Box>
                <FormControlLabel
                  value="CYCLE"
                  control={<Radio />}
                  disabled={status === 'detail'}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setDateType('CYCLE');
                    }
                  }}
                  // onChange={(e) => {
                  //   if (e.target.checked) {
                  //     setDisabled(false);
                  //     setBeginTimeValidate(true);
                  //   }
                  // }}
                  label={formatMessage({
                    id: 'marketing.people.regnotcon.n03.rdo07',
                  })}
                />
                {dateType === 'CYCLE' && (
                  <Box ml={3}>
                    <Controller
                      name="dateCycle"
                      defaultValue={dateCycle}
                      control={control}
                      as={
                        <RadioGroup
                          aria-label="gender"
                          name="dateCycle"
                          defaultValue={dateCycle}
                          disabled={status === 'detail'}
                        >
                          <Box className="frequency-many-wrapper">
                            <Box className="row">
                              {cycleTypeList?.map((item) => (
                                <FormControlLabel
                                  value={item.code}
                                  control={<Radio />}
                                  disabled={status === 'detail'}
                                  label={item.name}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setCycleStartTime(null);
                                      setDateCycle(item.code);
                                    }
                                  }}
                                />
                              ))}
                            </Box>
                            <Box className="frequency-select-wrapper" mt={2}>
                              <Box>
                                {dateCycle === 'WEEK' && (
                                  <Controller
                                    render={(pr) => (
                                      <FormControl
                                        sx={{ width: '100%' }}
                                        variant="standard"
                                        className="multiple-wrap-style"
                                        // disabled={
                                        //   (isAllCompanyState ?? deIsAllCompanyState) ===
                                        //     'true' || queryType === 'detail'
                                        // }
                                      >
                                        <InputLabel id="demo-multiple-chip-label">
                                          {formatMessage({
                                            id: 'marketing.people.regnotcon.n03.rdo09',
                                          })}
                                        </InputLabel>
                                        <Select
                                          labelId="demo-multiple-chip-label"
                                          name="dateDay"
                                          disabled={status === 'detail'}
                                          id="demo-multiple-chip"
                                          multiple
                                          value={dateWeekDay}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            setDateWeekDay(value);
                                            return pr.onChange(e.target.value);
                                          }}
                                          renderValue={() => {
                                            return dateWeekDay.length > 0 ? (
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  flexWrap: 'wrap',
                                                }}
                                              >
                                                {dateWeekDay.map((value) => (
                                                  <Chip
                                                    key={value}
                                                    label={(() => {
                                                      let list = weekDayList;
                                                      const data = list?.find(
                                                        (item) =>
                                                          item.id === value,
                                                      );
                                                      return <>{data?.name}</>;
                                                    })()}
                                                    sx={{ m: '2px' }}
                                                  />
                                                ))}
                                              </Box>
                                            ) : (
                                              ''
                                            );
                                          }}
                                          // MenuProps={MenuProps}
                                        >
                                          {weekDayList?.length > 0 &&
                                            weekDayList?.map((data) => (
                                              <MenuItem
                                                key={data.id}
                                                value={data.id}
                                                style={getStyles(
                                                  data.name,
                                                  '',
                                                  theme,
                                                )}
                                              >
                                                {data?.name}
                                              </MenuItem>
                                            ))}
                                        </Select>
                                      </FormControl>
                                    )}
                                    control={control}
                                    name="dateDay"
                                    error={Boolean(errors.dateDay)}
                                    rules={{ required: dateType === 'CYCLE' }}
                                  />
                                )}
                                {dateCycle === 'MONTH' && (
                                  <Controller
                                    render={(pr) => (
                                      <FormControl
                                        sx={{ width: '100%' }}
                                        variant="standard"
                                        className="multiple-wrap-style"
                                        // disabled={
                                        //   (isAllCompanyState ?? deIsAllCompanyState) ===
                                        //     'true' || queryType === 'detail'
                                        // }
                                      >
                                        <InputLabel id="demo-multiple-chip-label">
                                          {formatMessage({
                                            id: 'marketing.people.regnotcon.n03.rdo10',
                                          })}
                                        </InputLabel>
                                        <Select
                                          labelId="demo-multiple-chip-label"
                                          name="dateDay"
                                          id="demo-multiple-chip"
                                          multiple
                                          disabled={status === 'detail'}
                                          value={dateMonthDay}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            setDateMonthDay(value);
                                            return pr.onChange(e.target.value);
                                          }}
                                          renderValue={() => {
                                            return dateMonthDay.length > 0 ? (
                                              <Box
                                                sx={{
                                                  display: 'flex',
                                                  flexWrap: 'wrap',
                                                  height: 36,
                                                }}
                                              >
                                                {dateMonthDay.map((value) => (
                                                  <ButtonTip
                                                    title={dateMonthDay.join(
                                                      ',',
                                                    )}
                                                  >
                                                    <Chip
                                                      key={value}
                                                      label={(() => {
                                                        let list;
                                                        dateCycle === 'WEEK'
                                                          ? (list = weekDayList)
                                                          : (list =
                                                              monthDayList);
                                                        const data = list?.find(
                                                          (item) =>
                                                            item.id === value,
                                                        );
                                                        return (
                                                          <>{data?.name}</>
                                                        );
                                                      })()}
                                                      sx={{ m: '2px' }}
                                                    />
                                                  </ButtonTip>
                                                ))}
                                              </Box>
                                            ) : (
                                              ''
                                            );
                                          }}
                                          // MenuProps={MenuProps}
                                        >
                                          {monthDayList?.length > 0 &&
                                            monthDayList?.map((data) => (
                                              <MenuItem
                                                key={data.id}
                                                value={data.id}
                                                style={getStyles(
                                                  data.code,
                                                  '',
                                                  theme,
                                                )}
                                              >
                                                {data?.name}
                                              </MenuItem>
                                            ))}
                                        </Select>
                                      </FormControl>
                                    )}
                                    control={control}
                                    name="dateDay"
                                    error={Boolean(errors.dateDay)}
                                    rules={{ required: dateType === 'CYCLE' }}
                                  />
                                )}
                                <FormHelperText error={Boolean(errors.dateDay)}>
                                  {errors.dateDay?.type === 'required' &&
                                    formatMessage({
                                      id: 'marketing.people.regnotcon.n03.msg01',
                                    })}
                                </FormHelperText>
                              </Box>
                              <Box className="beginTime-wrapper" mt={5}>
                                <Controller
                                  control={control}
                                  sx={{ width: '100%' }}
                                  name="cycleTime"
                                  defaultValue={null}
                                  error={Boolean(errors.cycleTime)}
                                  rules={{
                                    required: dateType === 'CYCLE',
                                  }}
                                  render={() => (
                                    <TimePicker
                                      disabled={status === 'detail'}
                                      inputFormat="HH:mm"
                                      renderInput={(prop) => (
                                        <TextField
                                          {...prop}
                                          variant="standard"
                                        />
                                      )}
                                      label={formatMessage({
                                        id: 'marketing.people.regnotcon.n03.rdo11',
                                      })}
                                      name="cycleTime"
                                      value={cycleStartTime}
                                      onChange={(newValue) => {
                                        setValue('cycleTime', newValue);
                                        setCycleStartTime(newValue);
                                      }}
                                    />
                                  )}
                                />
                                <FormHelperText
                                  error={Boolean(errors.cycleTime)}
                                >
                                  {errors.cycleTime?.type === 'required' &&
                                    formatMessage({
                                      id: 'marketing.people.regnotcon.n03.msg02',
                                    })}
                                </FormHelperText>
                              </Box>
                              {cardType === 'CUSTOM_CROWD' && (
                                <Box mt={4}>
                                  <Controller
                                    name="date"
                                    control={control}
                                    render={(rp) => {
                                      return (
                                        <DateRangePickerML
                                          label=""
                                          disabled={status === 'detail'}
                                          startText="执行开始时间"
                                          endText="执行结束时间"
                                          defaultStartDate={
                                            activityGroupDetail?.cycleStartDate ||
                                            null
                                          }
                                          defaultEndDate={
                                            activityGroupDetail?.cycleEndDate ||
                                            null
                                          }
                                          rp={rp}
                                          setValue={setValue}
                                        />
                                      );
                                    }}
                                  />
                                </Box>
                              )}
                            </Box>
                          </Box>
                        </RadioGroup>
                      }
                    />
                  </Box>
                )}
              </Box>
            </RadioGroup>
          }
        />
      </Box>
      <ModalML
        open={openPeopleModal}
        setOpen={setOpenPeopleModal}
        onCancel={handlePeopleCancel}
        title={formatMessage({ id: 'marketing.people.regnotcon.n02.lbl02' })}
        onClose={onPeopleClose}
      >
        <PeopleModal
          userGroup={userGroup}
          onConfirm={handlePeopleSubmitSuccess}
          open={openPeopleModal}
          setOpen={setOpenPeopleModal}
        ></PeopleModal>
      </ModalML>
    </BasicInfoStyled>
  );
};
export default BasicInfo;
